import ApiBase from './ApiBase'
import getImageDataFromUrl from '@/logic/getImageDataFromUrl'
import ImageAnalyzer from '@/logic/ImageAnalyzer'
import Colorset from '../models/Colorset'

class ColorAnalyzerApi extends ApiBase {
  analyzeFromUrl (src) {
    return getImageDataFromUrl(src).then((data) => {
      return new ImageAnalyzer(data)
    }).catch(err => {
      console.warn('getImageDataFromUrl Err', src, err)
    })
  }
  colorsetFromUrl (src, colorCount) {
    const cacheKey = `colorset:${src}#${colorCount}`
    const cacheAgeMin = 60 * 24
    const cached = this.lscache.get(cacheKey)
    if (cached) {
      const cs = new Colorset()
      try {
        cs.fromObj(cached)
        return Promise.resolve(cs)
      } catch (err) {
        console.warn('invalid cached colorset', err)
      }
    }
    return this.analyzeFromUrl(src).then((an) => {
      const cs = an.clustering(colorCount)
      this.lscache.set(cacheKey, cs, cacheAgeMin)
      return cs
    })
  }
}

export default new ColorAnalyzerApi()



// WEBPACK FOOTER //
// ./src/api/ColorAnalyzerApi.js